import { render, staticRenderFns } from "./FilterTabs.vue?vue&type=template&id=5a39c987&lang=pug&"
import script from "./FilterTabs.vue?vue&type=script&lang=js&"
export * from "./FilterTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports